import script from "./PlayerControls.vue?vue&type=script&setup=true&lang=js"
export * from "./PlayerControls.vue?vue&type=script&setup=true&lang=js"

import "./PlayerControls.vue?vue&type=style&index=0&id=44a89ee4&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-44a89ee4"]])

export default __exports__